export class CourseFormatConstants{
    public static readonly InstructorLed: number = 0;
    public static readonly SelfStudy: number = 1;
}
